var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8306 0C19.7362 0 15.5732 4.16298 15.5732 9.25741V14.7521H21.7855V9.48593C21.7855 7.73575 23.1507 6.29608 24.8602 6.21701L24.861 6.21698C26.7045 6.13073 28.2451 7.61848 28.2451 9.4421V24.856H30.0647C32.2834 24.856 34.0881 23.046 34.0881 20.8327V9.25741C34.0881 4.16298 29.9251 0 24.8306 0ZM19.5966 24.3453C17.3778 24.3453 15.5732 26.1554 15.5732 28.3687V40.7395C15.5732 45.8366 19.7358 50 24.8306 50C29.925 50 34.088 45.837 34.088 40.7426V35.2479H27.8757V40.5579C27.8757 42.3316 26.4196 43.7877 24.6459 43.7877C22.8722 43.7877 21.4161 42.3316 21.4161 40.5579V24.3453H19.5966ZM40.7425 15.5734H35.2479V21.7857H40.5578C42.3315 21.7857 43.7876 23.2418 43.7876 25.0155C43.7876 26.7892 42.3315 28.2453 40.5578 28.2453H24.7446V30.0648C24.7446 32.2835 26.5547 34.0882 28.768 34.0882H40.7383H40.7394V32.6355L40.7383 34.0882C45.8369 34.0919 49.9999 29.9281 49.9999 24.8308C49.9999 19.7363 45.837 15.5734 40.7425 15.5734ZM9.25741 15.5733C4.16336 15.5733 0 19.7328 0 24.8308C0 29.9252 4.16298 34.0882 9.25741 34.0882H14.7521V27.8759H9.4421C7.66841 27.8759 6.2123 26.4198 6.2123 24.6461C6.2123 22.8724 7.66841 21.4163 9.4421 21.4163H25.2553V19.5967C25.2553 17.378 23.4453 15.5733 21.232 15.5733H9.25741Z",
    fill: "#73C7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/mini-logo.9ceaed74414e1788bdf0303c37875c1c.svg";
export { ForwardRef as ReactComponent };